// removed by extract-text-webpack-plugin
module.exports = {"example-description":"theme--example-description--24A31Rz4","exampleDescription":"theme--example-description--24A31Rz4"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/reportExample/theme.scss
// module id = 1131
// module chunks = 0